// src/module/common/components/IndustryContextWrapper.tsx
import useCurrentIndustry from "@/hooks/globalapis/useCurrentIndustry";
import { EducationProvider } from "@/module/education/context/EducationContext";
import { VideoProductionProvider } from "@/module/videoProduction/context/VideoProductionContext";
import { AcademyProvider } from "@/module/academy/context/AcademyContext";

export default function IndustryContextWrapper({
  children,
}: {
  children: React.ReactNode;
}) {
  const { industry } = useCurrentIndustry();

  if (industry?.id === 1) {
    return <EducationProvider>{children}</EducationProvider>;
  }

  if (industry?.id === 4) {
    return <VideoProductionProvider>{children}</VideoProductionProvider>;
  }

  if (industry?.id === 5) {
    return <AcademyProvider>{children}</AcademyProvider>;
  }

  return <>{children}</>;
}
